export const processVehicleData = (vehiculos) => {
  const brandCounts = vehiculos.reduce((acc, vehicle) => {
    const marca = vehicle.marca || "No especificada";
    acc[marca] = (acc[marca] || 0) + 1;
    return acc;
  }, {});

  const vehiclesByBrand = Object.entries(brandCounts)
    .map(([marca, cantidad]) => ({ marca, cantidad }));

  const stateCounts = vehiculos.reduce((acc, vehicle) => {
    acc[vehicle.estado] = (acc[vehicle.estado] || 0) + 1;
    return acc;
  }, {});

  const vehicleStates = Object.entries(stateCounts)
    .map(([estado, cantidad]) => ({ estado, cantidad }));

  return { vehiclesByBrand, vehicleStates };
};

export const processFuelData = (combustibles, filter = {}) => {
  let filteredData = [...combustibles];

  // Apply filters
  if (filter.type === 'byYear' && filter.year) {
    filteredData = combustibles.filter(c => {
      const date = new Date(c.fecha_y_hora);
      return !isNaN(date) && date.getFullYear() === filter.year;
    });
  } else if (filter.type === 'lastMonth') {
    const lastMonth = new Date();
    lastMonth.setMonth(lastMonth.getMonth() - 1);
    filteredData = combustibles.filter(c => new Date(c.fecha_y_hora) >= lastMonth);
  } else if (filter.type === 'lastYear') {
    const lastYear = new Date();
    lastYear.setFullYear(lastYear.getFullYear() - 1);
    filteredData = combustibles.filter(c => new Date(c.fecha_y_hora) >= lastYear);
  }

  // Process fuel by type
  const fuelTypeCounts = filteredData.reduce((acc, c) => {
    const tipo = c.producto || "No especificado";
    acc[tipo] = (acc[tipo] || 0) + parseFloat(c.litros_unidades || 0);
    return acc;
  }, {});

  const fuelByType = Object.entries(fuelTypeCounts)
    .map(([tipo, litros]) => ({ tipo, litros: parseFloat(litros.toFixed(2)) }))
    .filter(({ litros }) => litros >= 150);

  // Process monthly fuel consumption
  const fuelByMonth = {};
  filteredData.forEach(c => {
    const date = new Date(c.fecha_y_hora);
    if (!isNaN(date)) {
      const key = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}`;
      if (!fuelByMonth[key]) {
        fuelByMonth[key] = { litros: 0, costo: 0 };
      }
      fuelByMonth[key].litros += parseFloat(c.litros_unidades || 0);
      fuelByMonth[key].costo += parseFloat(c.imp_tot_yer || 0);
    }
  });

  const monthlyFuelData = Object.entries(fuelByMonth)
    .sort(([a], [b]) => new Date(b + "-01") - new Date(a + "-01"))
    .slice(0, 5)
    .reverse()
    .map(([key, data]) => {
      const [year, month] = key.split("-");
      const date = new Date(parseInt(year), parseInt(month) - 1);
      const mes = date.toLocaleString("default", { month: "long" });
      return {
        mes: `${mes} ${year}`,
        litros: parseFloat(data.litros.toFixed(2)),
        costo: parseFloat(data.costo.toFixed(2))
      };
    });

  return { fuelByType, monthlyFuelData };
};

export const processTopVehicles = (data, vehiculos, type = 'fuel') => {
  let vehicleMetrics = {};

  switch (type) {
    case 'fuel':
      vehicleMetrics = data.reduce((acc, c) => {
        const vehiculoId = c.vehiculo;
        const litros = parseFloat(c.litros_unidades || 0);
        if (!vehiculoId) return acc;
        acc[vehiculoId] = (acc[vehiculoId] || 0) + litros;
        return acc;
      }, {});
      break;

    case 'maintenance':
      vehicleMetrics = data.reduce((acc, record) => {
        const vehiculo = record.vehiculo;
        acc[vehiculo] = (acc[vehiculo] || 0) + 1;
        return acc;
      }, {});
      break;

    case 'infractions':
      vehicleMetrics = data.reduce((acc, record) => {
        const vehiculoId = record.vehiculo;
        if (!vehiculoId) return acc;
        acc[vehiculoId] = (acc[vehiculoId] || 0) + 1;
        return acc;
      }, {});
      break;

    default:
      return [];
  }

  return Object.entries(vehicleMetrics)
    .map(([vehiculoId, value]) => {
      const vehicle = vehiculos.find(v => String(v.id) === String(vehiculoId));
      const metricKey = type === 'fuel' ? 'litros' : 
                       type === 'maintenance' ? 'mantenimientos' : 'infracciones';
      
      return {
        patente: vehicle?.patente || `ID ${vehiculoId}`,
        [metricKey]: type === 'fuel' ? parseFloat(value.toFixed(2)) : value
      };
    })
    .sort((a, b) => {
      const metricKey = type === 'fuel' ? 'litros' : 
                       type === 'maintenance' ? 'mantenimientos' : 'infracciones';
      return b[metricKey] - a[metricKey];
    })
    .slice(0, 10);
};

export const processInfractionData = (infracciones) => {
  // Infractions by driver
  const infractionsByDriver = infracciones.reduce((acc, i) => {
    const conductor = i.conductor || "No asignado";
    acc[conductor] = (acc[conductor] || 0) + 1;
    return acc;
  }, {});

  const infractionData = Object.entries(infractionsByDriver)
    .map(([conductor, infracciones]) => ({ conductor, infracciones }));

  // Infractions by type
  const infractionTypes = infracciones.reduce((acc, i) => {
    const tipo = i.tipo_infraccion || "No especificado";
    acc[tipo] = (acc[tipo] || 0) + 1;
    return acc;
  }, {});

  const infractionsByType = Object.entries(infractionTypes)
    .map(([tipo, cantidad]) => ({ tipo, cantidad }));

  return { infractionData, infractionsByType };
};
